export enum Selectors {
	SELECT = '.ant-select-selector',
	SELECT_MENU_ITEM = '.ant-select-item-option',
	SELECT_MENU_ITEM_CONTENT = '.ant-select-item-option .ant-select-item-option-content',
	TABLE_HEADER = '.ant-table-thead .ant-table-cell'
}

export const TestIds = {
	FORMATTED_TIME_WINDOW: 'formatted-time-window',
	TEAM_GROUP_CELL: 'team-group-cell',
	TEAM_NAME_CELL: 'team-name-cell',
	GROUPED_ROW_CHECKBOX: 'grouped-row-checkbox',
	TABLE_ROW: 'table-row',
	TABLE_GROUP_ROW: 'table-group-row',
	TABLE_ROW_MEMO: 'table-row-memo',
	TABLE_GROUP_ROW_MEMO: 'table-group-row-memo',
	NO_DATA_MESSAGE: 'no-data-message',
	TABLE_LOADING_SPINNER: 'table-loading-spinner',
	BATCH_DISMISS_BUTTON: 'batch-dismiss-button'
};
